import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./ConfirmDialog.module.css";

export default function ConfirmDialog({
  open,
  title = "Confirmação",
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  confirmIcon,       // FontAwesome icon object, e.g. faPlay
  cancelIcon,        // FontAwesome icon object, e.g. faEye
  icon,              // FontAwesome icon object shown above title, e.g. faDumbbell
  confirmVariant = "danger",  // "danger" | "success" | "primary"
  onClose,
  onDismiss,         // Se passado, usado pelo X (só fecha); senão cai em onClose
  onConfirm,
  loading = false,
  loadingLabel = "Registrando...",
}) {
  if (!open) return null;

  const confirmBtnClass = [
    styles.btn,
    confirmVariant === "success" ? styles.btnSuccess :
    confirmVariant === "primary" ? styles.btnPrimary :
    styles.btnConfirm,
  ].join(" ");

  return (
    <div className={styles.overlay} onClick={loading ? undefined : onClose} role="presentation">
      <div
        className={styles.dialog}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={title}
      >
        <button
          type="button"
          className={styles.closeBtn}
          onClick={onDismiss ?? onClose}
          disabled={loading}
          aria-label="Fechar"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>

        {icon && (
          <div className={styles.iconWrap}>
            <FontAwesomeIcon icon={icon} className={styles.icon} />
          </div>
        )}

        <h3 className={styles.title}>{title}</h3>
        {typeof message === "string" ? (
          <p className={styles.message}>{message}</p>
        ) : (
          message
        )}

        <div className={styles.actions}>
          <button
            type="button"
            onClick={onClose}
            className={`${styles.btn} ${styles.btnCancel}`}
            disabled={loading}
          >
            {cancelIcon && <FontAwesomeIcon icon={cancelIcon} className={styles.btnIcon} />}
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={confirmBtnClass}
            disabled={loading}
          >
            {loading ? (
              <span className={styles.btnLoading}>
                <span className={styles.spinner} />
                {loadingLabel}
              </span>
            ) : (
              <>
                {confirmIcon && <FontAwesomeIcon icon={confirmIcon} className={styles.btnIcon} />}
                {confirmLabel}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
